export default __webpack_public_path__ + "static/media/Policy_on_Board_Diversity_2.6de28d23.pdf";